import React from 'react';

// components
import Page from '../../components/Page';
import VoucherList from '../../components/voucher/list';

export default function PageVoucherList() {
  return (
    <Page title="Voucher" path="/voucher/list">
      <VoucherList />
    </Page>
  );
}
